<template>
    <div class="content">
        <div class="container">
            <h1 class="mb-5">
                Bulk Clone Campaign
            </h1>
            <card-box v-show="status">
                <vue2-dropzone id="dropzone" :options="dropzoneOptions" :use-custom-slot="true" :duplicate-check="true"
                               ref="dropzone"
                               @vdropzone-upload-progress="processingStatus"
                               @vdropzone-processing="processing" @vdropzone-success="bulk"
                               @vdropzone-files-added="selected"
                               @vdropzone-complete="uploaded">
                    <h3 class="dropzone-custom-title">
                        Select your original or legally purchased images to upload
                    </h3>
                    <div class="subtitle">
                        File names will become the campaign name and URL path.
                    </div>
                </vue2-dropzone>
            </card-box>

            <card-box>
                <table v-if="files.length > 0" class="table table-striped  table-hover mt-3">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>File Name</th>
                        <th>Status</th>
                        <th>Url Path</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(file,index) in files" :key="index">
                        <th>{{ index + 1 }}</th>
                        <td>{{ file.name }}</td>
                        <td>
                            <b-progress v-if="file.status != 'success' && currentFile.name == file.name "
                                        :value="percent" :max="100" show-progress animated></b-progress>

                            <div v-if="currentFile.name != file.name">
                                    <span class="ml-2"
                                          :class="{'text-success':file.status == 'success','text-primary': file.status == 'uploading'}">
                                        <i v-if="file.status == 'success'" class="fi-check text-success"/>
                                        {{ file.status }}</span>
                            </div>
                        </td>
                        <td>
                            <a v-if="file.slug" target="_blank" :href="file.url">{{ file.slug }}</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="campaign">
                    <div class="mb-2">
                        <strong>Campaign to clone</strong>
                    </div>
                    <img :src="campaign.thumb" class="img-thumbnail thumb-xl mr-2">
                    <a target="_blank" :href="campaign.url"><strong>{{ campaign.name }}</strong></a>
                </div>
            </card-box>


            <h1 class="mb-3 mt-2">
                Notes
            </h1>
            <card-box>
                <card-title>Artwork File Names</card-title>
                Name your artwork files with the campaign names you want your campaigns to have. (An artwork file name
                will become the name and URL path of a new campaign).

                <card-title>For example:</card-title>
                <table class="table table-striped table-hover mt-3">
                    <thead>
                    <tr>
                        <th>File Name</th>
                        <th>Campaign Name</th>
                        <th>Url Path</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>I like to party.png</td>
                        <td>I like to party</td>
                        <td>i-like-to-party</td>
                    </tr>
                    <tr>
                        <td>I-like-to-party.png</td>
                        <td>I-like-to-party</td>
                        <td>i-like-to-party</td>
                    </tr>
                    </tbody>
                </table>

                <card-title>Bulk Upload Process:</card-title>

                We will process your request and confirm via email when your campaigns have been created.
            </card-box>
        </div>
    </div>
</template>

<script>
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import CardBox from "@/components/CardBox"
    import vue2Dropzone from 'vue2-dropzone'
    import CardTitle from "@/components/CardTitle";

    export default {
        name: "BulkClone",
        components: {CardTitle, CardBox, vue2Dropzone},
        data: function () {
            return {
                bulkQueue: [],
                bulkStatus: 0,
                currentFile: {},
                percent: 0,
                status: true,
                id: '',
                files: [],
                campaign: {},
                dropzoneOptions: {
                    autoProcessQueue: true,
                    parallelUploads: 1,
                    uploadMultiple: false,
                    createImageThumbnails: false,
                    maxFiles: 1000,
                    maxFilesize: 20,
                    previewTemplate: '<div></div>',

                    addRemoveLinks: false,
                    url: this.$config.api + 'design/upload',

                    headers: {
                        'Authorization': this.$http.defaults.headers.common['Authorization']
                    }
                }
            }
        },
        mounted: function () {
            this.get()
        },

        methods: {
            processingStatus: function (file, per) {
                this.currentFile = file
                this.percent = per
            },
            uploaded: function (file) {
                for (let i = 0; i < this.files.length; i++) {
                    if (file.name == this.files[i].name) {
                        this.$set(this.files[i], 'status', file.status)

                        if (i == this.files.length - 1) {
                            this.currentFile = {}
                        }
                    }
                }
            },

            bulk: async function (file, response) {
                //  this.bulk++
                let product = {}
                product.id = this.id
                product.file = file.name
                product.frontImage = response.url

                this.bulkQueue.push(product)

                this.bulkSend()
            },
            bulkSend: async function () {
                let vm = this
                if (this.bulkStatus == 1) return false
                this.bulkStatus = 1
                let product = this.bulkQueue.shift()
                if (!product) return false

                for (let i = 0; i < vm.files.length; i++) {
                    if (product.file == vm.files[i].name) {
                        vm.$set(vm.files[i], 'slug', 'create campaign...')
                        break
                    }
                }


                let res = await this.$http.post(this.$config.api + 'campaign/bulk', product)
                for (let i = 0; i < vm.files.length; i++) {
                    if (product.file == vm.files[i].name) {
                        vm.$set(vm.files[i], 'url', res.data.url)
                        vm.$set(vm.files[i], 'slug', res.data.slug)
                    }
                }
                this.bulkStatus = 0
                if (this.bulkQueue.length > 0) {
                    setTimeout(this.bulkSend(), 500)
                }
            },
            processing: function (file) {

                this.status = false
                for (let i = 0; i < this.files.length; i++) {
                    if (file.name == this.files[i].name) {
                        this.$set(this.files[i], 'status', file.status)
                    }
                }
            },
            selected: async function (files) {
                //   console.log(files)
                this.files = []
                for (let i = 0; i < files.length; i++) {
                    this.files.push({name: files[i].name, status: files[i].status})
                }
           //     this.$refs.dropzone.processQueue()


            },

            get: function () {
                this.id = this.$route.params.id
                let vm = this

                this.$http.get(this.$config.api + 'campaign/' + this.id).then(function (res) {
                    vm.campaign = res.data
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .campaign {
        padding: 1em;
        background: #eee;
    }

    .dropzone {
        overflow: hidden;
        padding: 0;

        .dz-details {
            overflow: hidden;
        }
    }
</style>